var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ConfirmationDialog2", { ref: "confirmationDialog" }),
      _vm._v(" "),
      _vm._t("default", null, { submit: _vm.submit, loading: _vm.loading }),
      _vm._v(" "),
      _c("ExecutionResultsDialog", {
        ref: "executionResultsDialog",
        on: {
          close: function ($event) {
            return _vm.$emit("reload")
          },
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function ({ isError }) {
              return [
                isError
                  ? _c(
                      "span",
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-1",
                            attrs: { large: "", color: "warning" },
                          },
                          [_vm._v("error")]
                        ),
                        _vm._v("\n        Failed to detect file type\n      "),
                      ],
                      1
                    )
                  : _c(
                      "span",
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-1",
                            attrs: { large: "", color: "success" },
                          },
                          [_vm._v("check_circle")]
                        ),
                        _vm._v(
                          "\n        File type detected successfully\n      "
                        ),
                      ],
                      1
                    ),
              ]
            },
          },
          {
            key: "actions",
            fn: function ({ FileResults }) {
              return [
                FileResults && FileResults.length > 0
                  ? _c("ul", [
                      _c(
                        "li",
                        { staticClass: "pb-2" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "dataset",
                                  params: { id: FileResults[0].FileId },
                                },
                              },
                            },
                            [_vm._v("Continue to the file")]
                          ),
                          _vm._v(".\n        "),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "pb-2" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "dataset",
                                  params: { id: FileResults[0].FileId },
                                },
                              },
                            },
                            [_vm._v("Review the file")]
                          ),
                          _vm._v(
                            " and its contents for any formatting mistakes. Reupload the file if any changes were made.\n        "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isTenantAdmin
                        ? _c("li", { staticClass: "pb-2" }, [
                            _vm._v(
                              "Customize the ingestion service configurations to better suit your file format."
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isTenantAdmin
                        ? _c(
                            "li",
                            { staticClass: "pb-2" },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "dataset",
                                      params: { id: FileResults[0].FileId },
                                    },
                                  },
                                },
                                [_vm._v("Manually set the file type")]
                              ),
                              _vm._v(" by editing the file.\n        "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("li", { staticClass: "pb-2" }, [
                        _vm._v(
                          "Contact your administrator or Hatfield if you require assistance."
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "next",
            fn: function ({ FileResults }) {
              return [
                !_vm.noNext
                  ? _c(
                      "PrimaryBtn",
                      {
                        attrs: {
                          color: "primary",
                          to: {
                            name: "dataset",
                            params: { id: FileResults[0].FileId },
                          },
                        },
                      },
                      [_vm._v("\n        View file\n      ")]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }